const questions = [
    {
        id: 1,
        question : "What is this all about?",
        answer: "We are creating a community of enthusiasts sharing, discussing and solving quality questions from various topics all around the world."
    },
    {
        id: 2,
        question : "What types of questions are there in the website?",
        answer: "Questions vary from various topics, examinations, olympiads, etc. Any quality questions that one can think of."
    },
    {
        id: 3,
        question : "Who can share questions?",
        answer: "Anybody who is enthusiatic enough can share questions, doesn't matter if you are a proffesor, student or an educator."
    },
    {
        id: 4,
        question : "Who can use this website?",
        answer: "A motivated student, entrance examination aspirants, an enthusiast, undergrads, postgrads, proffesors, teachers anybody who loves learning something new and challenging themselves."
    },
    {
        id: 5,
        question : "Is this website legit?",
        answer: "This website aims to be huge library of unique questions from across the world."
    }
];
export {questions};
